export default "__VITE_ASSET__CRkTkp7O__"